export default __webpack_public_path__ + "media/0fce3129cfa58a5f749cdca28a35f4f68a655a362c1a5ce8cb9a9e8eae3312a3.svg";